import React from "react";
import { downloadMailingList } from "../../../utils/apis/func";
import axios from "axios";

const General = () => {
  const exportToCsv = ({
    data,
    headers,
    keys,
    fileName,
  }: {
    data: any[];
    headers: string[];
    keys: string[];
    fileName: string;
  }) => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(",")]
        .concat(data.map((row) => keys.map((key) => row[key]).join(",")))
        .join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  };
  // const init_downloadMailingList = async () => {
  //   // https://api.pureworker.com/api/mailing-lists
  //   const res: any = await downloadMailingList("", "");
  //   console.log("====================================");
  //   console.log(res);
  //   console.log("====================================");
  //   const headers = ["Date", "email"];
  //   const keys = ["createdAt", "email"];
  //   const handleExportToCSV = () => {
  //     exportToCsv({
  //       data: res,
  //       headers,
  //       keys,
  //       fileName: "mailing.csv",
  //     });
  //   };
  //   handleExportToCSV();
  //   // try {
  //   //   // Call your API function to get the file URL
  //   //   const fileUrl:any = await downloadMailingList("", "");

  //   //   // Create a hidden anchor element
  //   //   const link:any = document.createElement("a");
  //   //   link.href = fileUrl?.data;
  //   //   link.download = "transactions"; // Specify the filename to be downloaded
  //   //   link.target = "_blank";
  //   //   document.body.appendChild(link);

  //   //   // Trigger the download by clicking the anchor element
  //   //   link.click();

  //   //   // Clean up by removing the anchor element
  //   //   document.body.removeChild(link);
  //   // } catch (error) {
  //   //   console.error("Error downloading file:", error);
  //   // }
  // };

  // const init_downloadWaitingList = async () => {
  //   // https://api.pureworker.com/api/mailing-lists
  //   const res: any = await downloadMailingList("", "");
  //   console.log("====================================");
  //   console.log(res);
  //   console.log("====================================");
  //   const headers = ["Date", "email"];
  //   const keys = ["createdAt", "email"];
  //   const handleExportToCSV = () => {
  //     exportToCsv({
  //       data: res,
  //       headers,
  //       keys,
  //       fileName: "mailing.csv",
  //     });
  //   };
  //   handleExportToCSV();
  // };

  const handleDownload = async () => {
    try {
      const AuthToken = localStorage.getItem("AuthToken");
      const response = await axios.get(
        "https://api.pureworker.com/api/mailing-lists",
        {
          responseType: "blob", // Important for handling the binary data
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "mailing.csv"; // Set the file name for the download
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const handleDownload2 = async () => {
    try {
      const AuthToken = localStorage.getItem("AuthToken");
      const response = await axios.get(
        "https://api.pureworker.com/api/waiting-lists?ex=true",
        {
          responseType: "blob", // Important for handling the binary data
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "waiting.csv"; // Set the file name for the download
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    // <div className="h-screen bg-[#F7F7F7]">
    //   <div className="px-3">
    //     <p className="text-[#000] font-roboto text-2xl font-medium leading-normal  border-b-2 border-[#000] w-fit px-4">
    //       Edit Settings
    //     </p>
    //   </div>
    //   <section className="flex flex-col px-2 lg:px-8 w-full lg:w-2/3  gap-7 mt-7 ">
    //     <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm ">
    //       <p className="flex items-center">
    //         Percentage before X stars:{" "}
    //         <input className="lg:ml-4 flex-grow bg-[#fff] rounded-lg px-1"></input>
    //       </p>
    //     </div>
    //     <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
    //       <p className="flex items-center">
    //         Percentage after X stars:{" "}
    //         <input className="lg:ml-4 flex-grow bg-[#fff] rounded-lg px-1"></input>
    //       </p>
    //     </div>
    //     <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
    //       <p className="flex items-center">
    //         X stars:{" "}
    //         <input className="lg:ml-4 flex-grow bg-[#fff] rounded-lg px-1"></input>
    //       </p>
    //     </div>
    //     <div className="flex-grow bg-[#8E8E93] border border-[#88087B] rounded-sm">
    //       <p className="flex items-center">
    //         Cities:{" "}
    //         <input className="lg:ml-4 flex-grow  bg-[#fff] rounded-lg px-1 space-x-2"></input>
    //       </p>
    //     </div>
    //     <button className="bg-[#88087B] text-[#FFCD1E] rounded-md text-center text-shadow font-roboto text-lg font-medium leading-normal w-full lg:w-1/5">
    //       Save Changes
    //     </button>
    //   </section>
    // </div>
    <div className="p-6">
      <div className="flex flex-col">
        <button
          onClick={(e) => {
            handleDownload2();
          }}
          className="bg-[#88087B] text-[#FFCD1E] text-center text-shadow font-roboto text-lg font-medium leading-normal sm:w-3/4 lg:w-[20%] lg:mx-auto py-2.5 rounded-md mt-4 "
        >
          Download waiting list
        </button>
        <button
          onClick={(e) => {
            handleDownload();
          }}
          className="bg-[#88087B] mt-4 text-[#FFCD1E] text-center text-shadow font-roboto text-lg font-medium leading-normal sm:w-3/4 lg:w-[20%] lg:mx-auto py-2.5 rounded-md mt-4 "
        >
          Download Mailing list
        </button>
      </div>
    </div>
  );
};

export default General;
